import React, { useState, useEffect } from "react";
import "./Header.css";
import Bars from "../../../assets/bars.png";
import logo from "../../../assets/logo.png";
import { Link } from "react-scroll";

const Header = () => {
  const [mobile, setMobile] = useState(window.innerWidth <= 768 ? true : false);
  const [menuOpened, setMenuOpened] = useState(false);

  // Add event listener to handle window resize
  useEffect(() => {
    const handleResize = () => {
      setMobile(window.innerWidth <= 768 ? true : false);
    };

    // Attach the event listener
    window.addEventListener("resize", handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="header">
      <img src={logo} alt="" className="logo" />
      {menuOpened === false && mobile === true ? (
        <div
          style={{
            backgroundColor: "var(--green)",
            opacity: "0.4",
            padding: "0.5rem",
            borderRadius: "5px"
          }}
          onClick={() => setMenuOpened(true)}
        >
          <img
            src={Bars}
            alt=""
            style={{ width: "1.5rem", height: "1.5rem" }}
          />
        </div>
      ) : (
        <ul className="header-menu">
          <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="Home"
              spy={true}
              smooth={true}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="programs"
              spy={true}
              smooth={true}
            >
              Our Strategies
            </Link>
          </li>
          <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="ExtraService"
              spy={true}
              smooth={true}
            >
              Extra Services
            </Link>
          </li>
          {mobile && (
            <li>
              <Link
                onClick={() => setMenuOpened(false)}
                to="Contact"
                spy={true}
                smooth={true}
              >
                Contact Us
              </Link>
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default Header;
